import React, { useEffect, useState } from "react";
import "./AdminHolidayList.css";
import Iridescence from "./Iridescence"; // your background component

function AdminHolidayList() {
  const [holidays, setHolidays] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editIdx, setEditIdx] = useState(null);
  const [form, setForm] = useState({ date: "", day: "", holidayName: "" });

  useEffect(() => {
    fetch("https://hrms.urbango.co.in/server/index.php?endpoint=holidays")
      .then((res) => res.json())
      .then((data) => setHolidays(data))
      .catch(() => setHolidays([]));
  }, []);

  function openAddModal() {
    setForm({ date: "", day: "", holidayName: "" });
    setEditIdx(null);
    setShowModal(true);
  }

  function openEditModal(idx) {
    setForm(holidays[idx]);
    setEditIdx(idx);
    setShowModal(true);
  }

  function handleDeleteHoliday(date) {
  if (!window.confirm("Delete this holiday?")) return;
  fetch("https://hrms.urbango.co.in/server/index.php?endpoint=delete_holiday", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ date }),
  })
    .then(res => res.json())
    .then(result => {
      if (result.success) {
        fetch("https://hrms.urbango.co.in/server/index.php?endpoint=holidays")
          .then(res => res.json())
          .then(data => setHolidays(data));
      } else alert("Failed to delete holiday!");
    });
}

  function handleFormChange(e) {
    setForm({ ...form, [e.target.name]: e.target.value });
  }

  function handleFormSubmit(e) {
    e.preventDefault();
    const endpoint = editIdx === null ? "add_holiday" : "edit_holiday";
    fetch(`https://hrms.urbango.co.in/server/index.php?endpoint=${endpoint}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(form),
    })
      .then((res) => res.json())
      .then(result => {
        if (result.success) {
          fetch("https://hrms.urbango.co.in/server/index.php?endpoint=holidays")
            .then(res => res.json())
            .then(data => setHolidays(data));
          setShowModal(false);
        } else {
          alert(result.message || "Action failed");
        }
      });
  }

  return (
    <div className="holiday-card">
      
      <div className="holiday-header-flex">
        <h2 className="holiday-title">Holiday List</h2>
        <button className="add-btn" onClick={openAddModal}>+ Add Holiday</button>
      </div>
      <table className="holiday-table">
        <thead>
          <tr>
            <th className="holiday-th">Date</th>
            <th className="holiday-th">Day</th>
            <th className="holiday-th">Holiday</th>
            <th className="holiday-th">Action</th>
          </tr>
        </thead>
        <tbody>
          {holidays.map((h, index) => (
            <tr key={index} className="holiday-row">
              <td className="holiday-td">{h.date}</td>
              <td className="holiday-td">{h.day}</td>
              <td className="holiday-td">{h.holidayName}</td>
              <td className="holiday-td">
  <button className="edit-btn" onClick={() => openEditModal(index)}>Edit</button>
  <button className="delete-btn" onClick={() => handleDeleteHoliday(h.date)}>Delete</button>
</td>
            </tr>
          ))}
        </tbody>
      </table>

      {showModal && (
        <div className="modal-bg">
          <form className="modal-form" onSubmit={handleFormSubmit}>
            <h3>{editIdx === null ? "Add Holiday" : "Edit Holiday"}</h3>
            <input
              name="date"
              type="date"
              value={form.date}
              onChange={handleFormChange}
              required
              placeholder="YYYY-MM-DD"
            />
            <input
              name="day"
              value={form.day}
              onChange={handleFormChange}
              required
              placeholder="Day"
            />
            <input
              name="holidayName"
              value={form.holidayName}
              onChange={handleFormChange}
              required
              placeholder="Holiday Name"
            />
            <div className="form-actions">
              <button className="add-btn" type="submit">
                {editIdx === null ? "Add" : "Save"}
              </button>
              <button className="cancel-btn" type="button" onClick={() => setShowModal(false)}>
                Cancel
              </button>
              
            </div>
          </form>
          
        </div>
      )}
    </div>
  );
}

export default AdminHolidayList;
